<script lang="ts" setup>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';

const { $events } = useEvents();
const { $alert } = useAlerts();
const { $t } = useLocalization();

defineProps<{
    enabled: boolean;
    selected: any;
}>();

const emit = defineEmits<{
    (e: 'error'): void;
}>();

const image = ref(null);
const x = ref(0);
const y = ref(0);
const width = ref(0);
const height = ref(0);

const cropper = ref<Cropper>(null);

const changed = (): void =>
{
    const data = cropper.value.getData(true);

    x.value = data.x;
    y.value = data.y;
    width.value = data.width;
    height.value = data.height;

    $events.$emit('filemanager::cropper::changed', {
        x: x.value,
        y: y.value,
        width: width.value,
        height: height.value
    });
};

const onError = (): void =>
{
    $alert.error($t('[[[Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.]]]'));
    emit('error');
};

onMounted(() =>
{
    cropper.value = new Cropper(image.value, {
        viewMode: 2,
        responsive: true,
        background: false,
        zoomable: false,
        ready: changed,
        cropend: changed,
        restore: false
    });
});
</script>

<template>
    <div class="mb-2">
        <img ref="image" :src="$filters.baseurl(selected.url)" :alt="selected.name" style="max-width: 100%;" @error="onError">
        <div class="text-center p-2">
            <div class="d-inline rounded bg-dark text-white px-2 py-1">
                <span class="text-secondary">x:</span> {{ x }}px
                <span class="text-secondary ms-2">y:</span> {{ y }}px
                <span class="text-secondary ms-2">width:</span> {{ width }}px
                <span class="text-secondary ms-2">height:</span> {{ height }}px
            </div>
        </div>
    </div>
</template>

<style>
.cropper-modal {
    background-color: transparent !important;
}
</style>
